import script from "./knowledge.vue?vue&type=script&setup=true&lang=js"
export * from "./knowledge.vue?vue&type=script&setup=true&lang=js"

import "./knowledge.vue?vue&type=style&index=0&id=4c0f93c6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c0f93c6"]])

export default __exports__